import React from 'react';
import SectionLayout from 'src/app/atoms/Layout/Section/SectionLayout';
import PeopleMagicImageAndContent from 'src/app/organisms/Homepage/PeopleMagicImageAndContent/PeopleMagicImageAndContent';

const PeopleMagicBlock = (): JSX.Element => (
  <SectionLayout
    padding={['spacing-7xl', 'spacing-xl']}
    paddingSm={['spacing-4xl', 'spacing-xl']}
    maxWidth='width-3xl'
  >
    <PeopleMagicImageAndContent />
  </SectionLayout>
);

export default PeopleMagicBlock;
